import { connect } from 'react-redux';
import {withRouter} from "react-router-dom";
import Component from './Component';
import {
  handleChange,
  editProfile,
  toggleShowChangeEmailModal,
  changeUserEmail,
  toggleShowChangePasswordModal,
  changeUserPassword,
  toggleShowDeleteAccountModal,
  deleteAccount
} from './Actions';

const stateToProps = (state) => {
  return {
    successUpdated: state.profile.successUpdated,
    userData: state.profile.dataForEdit,
    error: state.profile.error,
    isOpenModalChangeEmail: state.profile.isOpenModalChangeEmail,
    isOpenModalChangePassword: state.profile.isOpenModalChangePassword,
    isOpenModalDeleteAccount: state.profile.isOpenModalDeleteAccount,
  }
};

const dispatchToProps = (dispatch) => {
  return {
    handleChange: (e) => {
      dispatch(handleChange(e))
    },
    editProfile: () => {
      dispatch(editProfile())
    },
    toggleShowChangeEmailModal: () => {
      dispatch(toggleShowChangeEmailModal())
    },
    changeUserEmail: (data) => {
      dispatch(changeUserEmail(data))
    },
    toggleShowChangePasswordModal: () => {
      dispatch(toggleShowChangePasswordModal())
    },
    changeUserPassword: (data) => {
      dispatch(changeUserPassword(data))
    },
    toggleShowDeleteAccountModal: () => {
      dispatch(toggleShowDeleteAccountModal())
    },
    deleteAccount: (data) => {
      dispatch(deleteAccount(data))
    }
  }
};

export default withRouter(connect(stateToProps, dispatchToProps)(Component));


// WEBPACK FOOTER //
// ./src/app/containers/Profile/index.js